import { useSiteData } from "../../context/SiteData";
import { MARQUEE_ITEMS } from "../../data/site";

export const Marquee = () => {
  const { content } = useSiteData();
  const items = content.marquee_items
    ? content.marquee_items.split(",").map((s) => s.trim()).filter(Boolean)
    : MARQUEE_ITEMS;

  return (
    <div
      data-testid="marquee-strip"
      className="overflow-hidden border-y border-line bg-cream-100 py-5"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee gap-0">
        {[...items, ...items].map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-8 pr-8 text-[12px] font-semibold uppercase tracking-[0.26em] text-ink-500"
          >
            {item}
            <span className="h-1.5 w-1.5 rounded-full bg-ink-400/50" />
          </span>
        ))}
      </div>
    </div>
  );
};
